import React from 'react';

export function InvalidConfigComponentPlaceholder({label}) {
  return <>
    <label><span className="field-label">{label}</span></label>
    <p className='text-danger'>Invalid configuration</p>
  </>
}

export function InvalidConfigMessage({errors}){

  const translation = (key, {prefix = '', params = {}}) => {
    const keys = `config_validation_${prefix}${key}`.split('.');
    return keys.length > 1
      ? I18n.t(keys[0], { scope: 'fe', ...params })[keys[1]]
      : I18n.t(keys[0], { scope: 'fe', ...params });
  }

  const messages = errors.map(error => {
      if (error.name === 'required') {
        return translation(error.name, 
          { params: {
            field: translation(error.argument, {prefix: 'field_'})
          }}
        )

      }
      // Need to use minLength to filter out empty string, use required message still.
      // Additionally consider wrong type as required (null)
      if ((error.name === 'minLength' && error.argument === 1) || error.name === 'type') {
        return translation('required', 
          { params: {
            field: translation(error.path.filter(p => isNaN(p)).join('.'), {prefix: 'field_'})
          }}
        )
      }
    
      if (error.name === 'minLength') {
        return translation(error.name, 
          { params: {
            length: error.argument,
            field: translation(error.path.join('.'), {prefix: 'field_'})
          }}
        )
      }
  })

  return <div className='alert-danger p-1'>
    {messages.map((message,idx) => <div key={`error-${idx}`}>
      {message}
    </div>
      )}
  </div>
}